export enum ContactFormSubject {
	SUBJECT_1 = 'ContactForm.Subject.Subject1',
	SUBJECT_2 = 'ContactForm.Subject.Subject2',
	SUBJECT_3 = 'ContactForm.Subject.Subject3'
}

export enum ContactFormRecallTime {
	TIME_1 = 'ContactForm.RecallTime.Time1',
	TIME_2 = 'ContactForm.RecallTime.Time2',
	TIME_3 = 'ContactForm.RecallTime.Time3',
	TIME_4 = 'ContactForm.RecallTime.Time4',
	TIME_5 = 'ContactForm.RecallTime.Time5',
}
